import * as _Bootstrap from 'bootstrap';

import App from '../svelte/components/Bout.svelte';

const appPlaceholder = document.querySelector('#bout-page');

if (appPlaceholder) {
	new App({
		target: appPlaceholder,
		hydrate: true
	});
}
